export default "__VITE_ASSET__CAw03Qsy__"